import { useModalStore } from '@/shared/lib';
import { DisplaySettingsModal } from '../ui';

interface Props {
  onBack: () => void;
}

const useDisplaySettingsModal = () => {
  const { showDialogComponent } = useModalStore();

  const openDisplaySettingsModal = ({ onBack }: Props) => {
    showDialogComponent({
      component: <DisplaySettingsModal onBack={onBack} />,
    });
  };

  return { openDisplaySettingsModal };
};

export { useDisplaySettingsModal };
